module.exports = __webpack_public_path__ + "img/messages.ea8e9c94.svg";